import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useLocalStorage from 'react-use-localstorage'

import dayjs from 'dayjs'
import { locales } from 'i18n'

import { useAppSelector } from 'redux/hooks'
import { parseLanguageLocalStorage } from 'utils/helperLocalStorage'

const LanguageRender = () => {
    const { currentUser } = useAppSelector(state => state.user)
    const { i18n } = useTranslation()
    const [localStorage, setLocalStorage] = useLocalStorage('landingLang', 'null')
    const localStorageParsed = parseLanguageLocalStorage(localStorage)
    const { languageCode } = { ...currentUser }

    useEffect(() => {
        if (!languageCode && !!localStorageParsed && !!locales[localStorageParsed]) {
            i18n.changeLanguage(localStorageParsed)
            locales[localStorageParsed]().then(() => dayjs.locale(localStorageParsed))
        }
    }, [localStorageParsed, languageCode])

    useEffect(() => {
        if (languageCode) {
            i18n.changeLanguage(languageCode)
            setLocalStorage(JSON.stringify(languageCode))
            locales[languageCode]().then(() => dayjs.locale(languageCode))
        }
    }, [languageCode])

    return null
}

export default LanguageRender
